import React from 'react'
import { buildRuleSummary } from '../../../utils/ruleDataSource'

export default function RuleBuilderSummaryStrip({ dataSource, processingCategory }) {
  const summary = buildRuleSummary({ dataSource, processingCategory })

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 space-y-2">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Summary</div>
      <dl className="grid grid-cols-1 gap-1.5 text-sm text-slate-800">
        <div className="flex flex-wrap gap-x-2">
          <dt className="text-slate-500 shrink-0">Data source:</dt>
          <dd className="font-medium">{summary.dataSourceLabel}</dd>
        </div>
        <div className="flex flex-wrap gap-x-2">
          <dt className="text-slate-500 shrink-0">Grain:</dt>
          <dd className="font-medium">{summary.grainLabel}</dd>
        </div>
        <div className="flex flex-wrap gap-x-2">
          <dt className="text-slate-500 shrink-0">Runs on:</dt>
          <dd>{summary.runsOn}</dd>
        </div>
        {summary.pipelineNeeds.length > 0 && (
          <div className="flex flex-wrap gap-x-2">
            <dt className="text-slate-500 shrink-0">Pipeline needs:</dt>
            <dd>{summary.pipelineNeeds.map((step) => `${step} ✓`).join('  ')}</dd>
          </div>
        )}
        {summary.fieldsHint && (
          <div className="flex flex-wrap gap-x-2">
            <dt className="text-slate-500 shrink-0">Fields:</dt>
            <dd className="font-mono text-xs">{summary.fieldsHint}</dd>
          </div>
        )}
      </dl>
      {summary.pipelineNote && (
        <p className="text-xs text-slate-600 leading-relaxed border-t border-slate-200 pt-2">
          {summary.pipelineNote}
        </p>
      )}
      {summary.dataSourceNote && (
        <p className="text-xs text-amber-800 bg-amber-50 border border-amber-100 rounded px-2 py-1.5">
          {summary.dataSourceNote}
        </p>
      )}
    </div>
  )
}
